import createButton from './buttonFactory';

const secondaryStyles =
  'border border-white/60 bg-white/80 text-[var(--neutral-700)] shadow-[0_18px_50px_-40px_rgba(15,20,40,0.55)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-white focus-visible:ring-[rgba(161,196,253,0.35)]';

const SecondaryButton = createButton(secondaryStyles, 'SecondaryButton');

export default SecondaryButton;
